import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Page Not Found (404) — JP AI Dorks</title>
        <meta name="description" content="The page you were looking for doesn't exist on JP AI Dorks. Return to the homepage to keep generating Google dorks." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://jp-dork.space/" />
        <meta property="og:title" content="Page Not Found — JP AI Dorks" />
        <meta property="og:description" content="That URL doesn't exist on JP AI Dorks." />
        <meta property="og:url" content="https://jp-dork.space/" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
